import {replaceCurrentElementWithNewId} from "../../../helpers/helper";
import {DownloadImage} from "./downloadCanvas.ts";

const dialog = document.getElementById("previewDialog") as HTMLDialogElement;
const uploadLogoDialog = document.getElementById("uploadLogoDialog") as HTMLDialogElement;
const removeButton = document.getElementById('removeBackgroundFromLogo');

function addPreviewImage() {
  const url = DownloadImage(" ", "image", false);

  const dialogHtml = `
   <img src=${url} alt="final-image"/>
   `;

  replaceCurrentElementWithNewId("imageContainer", dialogHtml);
}

function addPreviewEvents() {
  const openPreviewBtn = document.getElementById("openPreviewBtn");
  const closePreviewBtn = document.getElementById("closePreviewBtn");

  [openPreviewBtn, closePreviewBtn]?.forEach((toolBtn) => {
    toolBtn.addEventListener("click", () => {
      if (toolBtn.id === "openPreviewBtn") {
        dialog.showModal();
        addPreviewImage();
      } else {
        dialog.close();
      }
    });
  });

  document
    .getElementById("downloadImgPreview")
    .addEventListener("click", () => {
      const imageName = Date.now().toString();
      DownloadImage(imageName);
    });
}

export function finishBtnEvents() {
  const toolBtn = document.getElementById('finishBtn');
  if(!toolBtn) return;
  toolBtn.addEventListener('click', function () {
    const backBtn = document.getElementById('back-toolBtn');
    if (!backBtn) return;
    if (confirm("Are you sure editing is completed?")) {
      backBtn.click();
    }
  })
}

export function removeBackgroundCheckbox() {
  uploadLogoDialog.close();
  if (removeButton) {
    removeButton.checked = false;
  }
}

export const initialisePopupFunctions = () => {
  addPreviewEvents();
  finishBtnEvents(); 
};
